<script>
import Vue from "vue";
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import "v-tooltip/dist/v-tooltip.css";
import Loader from "@/components/widgets/loader";

export default {
    mixins: [Api, Sabit],
    props: ["DonemId", "IcKontrolDonemId", "Donemler"],
    components: {
        Loader
    },
    data() {
        return {
            Page: {
                PageNumber: "1",
                PageSize: "9999",
                PageDataSize: "1",
            },
            TableData: {},
            DonemAdi: "",
            loading: true,
            uri: "data:application/vnd.ms-excel;base64,",
            template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
            base64: function (s) {
                return window.btoa(unescape(encodeURIComponent(s)));
            },
            format: function (s, c) {
                return s.replace(/{(\w+)}/g, function (m, p) {
                    return c[p];
                });
            },
        };
    },
    watch: {
        DonemId() {
            this.Get();
        },
    },
    methods: {
        Get() {
            let Filter = "&DonemId=" + this.IcKontrolDonemId + "&UstDonemId=" + this.DonemId;
            this.ActionsFilterGet({ Service: "StrRaporlama/GetSoruFormuKurumBazli", Page: this.Page, Filter: Filter }).then((res) => {
                this.TableData = res.Data.AnaGruplar;
                for (var Donem in this.Donemler) {
                    if (this.Donemler[Donem].Id == this.IcKontrolDonemId) {
                        this.DonemAdi = this.Donemler[Donem].Aciklama
                    }
                }


            });

        },
        ExcelExport(table, name) {
            if (!table.nodeType) table = this.$refs.veriGiris;
            var html = table.innerHTML
            var ctx = { worksheet: name || 'Worksheet', table: html }
            var a = document.createElement('a');
            a.href = this.uri + this.base64(this.format(this.template, ctx));
            a.download = name + '.xls';
            a.click();
        },
        ortalama(Puan, BirimSayisi){
            var ortalama = 0;
            if(Puan > 0){
              ortalama = Math.round((Puan*100)/(BirimSayisi*2))
            }else{
              ortalama = 0;
            }

            return ortalama;
        }
        
    },
    computed: {},
    created() {
        this.Get();
    },
};
</script>
<template>
    <Loader>
        <div>
            <div class="text-sm-end">
                <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="
                    ExcelExport(
                        'Eylem Skorları (Kurum Bazlı)',
                        'Eylem Skorları (Kurum Bazlı)',
                    )
                ">
                    <i class="mdi mdi-file-export-outline me-1"></i>
                    Excel'e Aktar
                </button>
            </div>
            <div ref="veriGiris" class="table-responsive">
                <div class="table-responsive">
                    <table class="table table-borderless mb-0" style="border-collapse: collapse; width: 100%">
                        <tr>
                            <td colspan="12" class="h5"
                                style="text-align: center;border-color: #0049B7; border-style: solid; font-family: Arial; display: block;">
                                Eylem Skorları (Kurum Bazlı) <br>
                            </td>
                        </tr>
                    </table>
                    <br>
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="table-responsive" v-for="(Data, index) in TableData" :key="index">
                                    <div v-if="Data.Tanimlar.length > 0 && Data.Tanimlar[0].Eylemler.length > 0 ">  
                                    <table class="table table-striped table-bordered mb-0" >
                                        <thead>
                                            <tr style="background-color: #0049B7;" >
                                                <th  colspan="12" class="col-md-12">{{ Data.AnaGrupValue }}</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <table class="table table-striped table-bordered mb-0" >
                                        <thead>
                                            <tr style="background-color: #00ACB7;">
                                                <th colspan="6" class="col-md-6">Eylem</th>
                                                <th colspan="2" style="text-align: center;">Toplam Puan</th>
                                                <th colspan="2" style="text-align: center;">Birim Sayısı</th>
                                                <th colspan="2" style="text-align: center;">Ortalama(%)</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <table class="table table-striped table-bordered mb-0" v-for="(SubData, index) in Data.Tanimlar" :key="index">
                                        <tbody v-for="(Eylem, index) in SubData.Eylemler" :key="index" >
                                            <tr>
                                                <td colspan="6" class="col-md-6">{{ Eylem.EylemValue }}</td>
                                                <td colspan="2" class="col-md-2" style="text-align: center;">{{ Eylem.Puan }}</td>
                                                <td colspan="2" class="col-md-2" style="text-align: center;">{{ Eylem.BirimSayisi }}</td>
                                                <td colspan="2" class="col-md-2" style="text-align: center;">{{ ortalama(Eylem.Puan, Eylem.BirimSayisi) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br/><br/>
                                </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </Loader>
</template>
